'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxSimple = require('redux-simple');

var _Markup = require('../../../components/Common/Markup');

var _Common = require('../../../components/Common');

var _projectsActions = require('../../../actions/projectsActions');

var _projectPermissions = require('../../../components/Projects/projectPermissions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./ProjectVisibility.pcss');

var getState = function getState(state) {
  return {
    project: state.projects.project,
    authorizedUser: state.user.authorizedUser
  };
};

var ProjectVisibility = (_dec = (0, _reduxSimple.connect)(getState, { setPermission: _projectsActions.setPermission }), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(ProjectVisibility, _Component);

  function ProjectVisibility(props) {
    _classCallCheck(this, ProjectVisibility);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ProjectVisibility).call(this, props));

    _this.state = {
      permission: (0, _projectPermissions.getPermission)(props.project, props.authorizedUser.publicProjects)
    };
    return _this;
  }

  _createClass(ProjectVisibility, [{
    key: 'handleSelected',
    value: function handleSelected(val) {
      this.setState({ permission: val });
    }
  }, {
    key: 'handleAccept',
    value: function handleAccept() {
      var _parsePermission = (0, _projectPermissions.parsePermission)(this.state.permission);

      var isPublic = _parsePermission.isPublic;
      var isListed = _parsePermission.isListed;

      this.props.setPermission(this.props.authorizedUser.id, this.props.project.id, isPublic, isListed);
      this.props.onSubmitted();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: styles.projectVisibility },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          _react2.default.createElement(
            _Markup.HeadingMedium,
            { noMargins: true },
            'Set project visibility'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.options },
          _react2.default.createElement(
            _Common.CheckBox.Group,
            { onSelect: this.handleSelected.bind(this), defaultSelected: this.state.permission },
            _react2.default.createElement(
              _Common.CheckBox.Item,
              { id: _projectPermissions.PERMISSIONS.PUBLIC },
              _react2.default.createElement(_Common.CheckBox.Icon, null),
              _react2.default.createElement(
                _Common.CheckBox.Label,
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Public'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _Markup.Faded,
                  null,
                  'Anyone can see it.'
                )
              )
            ),
            _react2.default.createElement(
              _Common.CheckBox.Item,
              { id: _projectPermissions.PERMISSIONS.UNLISTED },
              _react2.default.createElement(_Common.CheckBox.Icon, null),
              _react2.default.createElement(
                _Common.CheckBox.Label,
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Unlisted'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _Markup.Faded,
                  null,
                  'Only those with the link can see it.'
                )
              )
            ),
            _react2.default.createElement(
              _Common.CheckBox.Item,
              { id: _projectPermissions.PERMISSIONS.PRIVATE },
              _react2.default.createElement(_Common.CheckBox.Icon, null),
              _react2.default.createElement(
                _Common.CheckBox.Label,
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Private'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _Markup.Faded,
                  null,
                  'Only you can see it.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.accept },
            _react2.default.createElement(
              _Common.Button,
              { light: true, onClick: this.handleAccept.bind(this) },
              'ACCEPT'
            )
          )
        )
      );
    }
  }]);

  return ProjectVisibility;
}(_react.Component), _class2.propTypes = {
  onSubmitted: _react.PropTypes.func.isRequired,
  project: _react.PropTypes.object.isRequired,
  authorizedUser: _react.PropTypes.object,
  setPermission: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ProjectVisibility;


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/ProjectVisibility/ProjectVisibility.js
// module id = 579
// module chunks = 1